import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_WRK = process.env.REACT_APP_API_WRK;

const allServices = [
  { name: "Plumber", certification: "required" },
  { name: "Electrician", certification: "required" },
  { name: "Lawn Cleaning", certification: "not required" },
  { name: "Cleaning", certification: "not required" },
  { name: "Furniture Assembly", certification: "not required" },
  { name: "Roof Cleaning", certification: "optional" },
  { name: "Barber", certification: "required" },
  { name: "Moving", certification: "not required" },
  { name: "Child Care", certification: "required" },
  { name: "Handyman", certification: "not required" },
  { name: "Junk Removal", certification: "not required" },
  { name: "Snow Removal", certification: "not required" },
  { name: "Window Cleaning", certification: "optional" },
  
  // Beauty Services
  { name: "Haircut & Styling (Women)", certification: "required" },
  { name: "Pedicure & Manicure", certification: "required" },
  { name: "Facial & Skin Care", certification: "required" },
  { name: "Threading / Waxing", certification: "optional" },
  { name: "Makeup Artist (Event)", certification: "required" },
  { name: "At-Home Spa (Massage)", certification: "required" },
  { name: "Bridal Makeup", certification: "required" },

  // Car & Mechanic
  { name: "Car Detailing", certification: "not required" },
  { name: "Mechanic", certification: "required" },

  // Home & Repairs
  { name: "Painter", certification: "optional" },
  { name: "Appliance Repair", certification: "optional" },
  { name: "Flooring Repair", certification: "optional" },

  // Events & Special Work
  { name: "Event Photographer", certification: "optional" },
  { name: "Personal Chef", certification: "optional" },
  { name: "TV Mounting", certification: "not required" },
  { name: "Carpet Cleaning", certification: "not required" },
  { name: "Pressure Washing", certification: "not required" },
  { name: "Pool / Hot Tub Cleaning", certification: "optional" },

  // Extra Services
  { name: "Driver", certification: "required" },
  { name: "Respite Worker", certification: "required" },
  { name: "Mehndi", certification: "optional" },
  { name: "Tutor / Teaching", certification: "required" },
];

const SelectServices = () => {
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const toggleService = (serviceName) => {
    setSelected((prev) =>
      prev.includes(serviceName)
        ? prev.filter((name) => name !== serviceName)
        : [...prev, serviceName]
    );
  };

  const handleContinue = async () => {
    const selectedServices = allServices.filter((service) =>
      selected.includes(service.name)
    );
    const workerId = localStorage.getItem("workerId");

    if (!workerId) {
      alert("Session expired. Please log in again.");
      navigate("/worker-login");
      return;
    }

    try {
      setLoading(true);

      // ✅ Save selected services in MongoDB
      await axios.post(`${API_WRK}/save-services`, {
        workerId,
        services: selectedServices.map((s) => ({
          name: s.name,
          certUrl: "",
          hasTools: false,
          hasTruck: s.name === "Moving" ? false : undefined,
        })),
      });

      // ✅ Navigate to certification upload step
      navigate("/service-upload", { state: { selectedServices } });
    } catch (err) {
      console.error("❌ Failed to save services:", err);
      alert(err?.response?.data?.message || "Failed to save selected services.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-slate-100 p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-center text-indigo-700 mb-6">
          Select Services You Can Provide
        </h1>

        {/* FLOWY BUTTONS */}
        <div className="flex flex-wrap gap-3 justify-start">
          {allServices.map((service, index) => {
            const isSelected = selected.includes(service.name);
            return (
              <div
                key={index}
                onClick={() => toggleService(service.name)}
                className={`px-4 py-2 rounded-full cursor-pointer border text-sm font-medium transition duration-150 ${
                  isSelected
                    ? "border-indigo-500 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-400"
                    : "border-gray-300 text-gray-700 bg-white hover:border-indigo-300"
                }`}
              >
                {service.name}
              </div>
            );
          })}
        </div>

        {/* Certification Notes */}
        {selected.length > 0 && (
          <div className="mt-6 bg-white p-4 rounded-xl shadow-sm">
            <h3 className="text-md font-semibold text-gray-700 mb-2">
              Selected Services & Certifications:
            </h3>
            <ul className="list-disc pl-5 text-sm text-gray-600 space-y-1">
              {selected.map((name) => {
                const cert =
                  allServices.find((s) => s.name === name)?.certification ||
                  "unknown";
                return (
                  <li key={name}>
                    <span className="font-medium">{name}</span>:{" "}
                    <span className="capitalize">{cert}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        <div className="mt-8 text-center">
          <button
            disabled={selected.length === 0 || loading}
            onClick={handleContinue}
            className={`px-6 py-3 text-white font-semibold rounded-xl transition ${
              selected.length === 0 || loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700"
            }`}
          >
            {loading ? "Saving..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectServices;
